import { useCallback, useEffect, useMemo } from "react";
import { useAppDispatch } from "../../../services/redux/hooks/use-dispatch";
import {
  editStorageObject,
  fetchAllStorageObjects,
} from "../../../app/state/storageObjectSlice/actions/actions";
import { useStorageSelectors } from "../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { useMenuSelectors } from "../../../app/state/menuSlice/hook/use-menu-selectors";
import { setSchemaValue } from "../redux/slice";
import { getFileConfig } from "../../Files/helpers";
import { getFileContentByHash } from "../../../services/api/instances/saveFileApi/methods";

export const useImportSchemaMenu = (loadXml: (xml: string) => void) => {
  const dispatch = useAppDispatch();
  const importSchema = useMenuSelectors("import_drawio_schema_menu");
  const { objects } = useStorageSelectors("userfiles");
  const { selectedObject } = useStorageSelectors("schemas");
  const filteredSchemas = useMemo(() => {
    return objects.filter(
      (o) => o.value !== null && o.friendly_name.endsWith(".drawio"),
    );
  }, [objects]);

  useEffect(() => {
    if (importSchema.isOpen) {
      dispatch(fetchAllStorageObjects({ service: "userfiles" }));
    }
  }, [importSchema.isOpen]);

  const handleImportSchema = useCallback(
    async (hash: string, fileName: string) => {
      const fileConfig = getFileConfig(fileName);
      if (!selectedObject || !selectedObject.value || !fileConfig) return;
      const content = await getFileContentByHash(hash, fileConfig, fileName);
      const xml = typeof content === "string" ? content : "";
      const updatedValue = {
        ...selectedObject?.value,
        schemas_object: {
          ...selectedObject?.value?.schemas_object,
          schema_xml: xml,
        },
      };
      dispatch(
        editStorageObject({
          id: selectedObject?.id ?? "",
          name: selectedObject?.friendly_name ?? "",
          value: updatedValue,
          service: "schemas",
        }),
      );
      dispatch(setSchemaValue(updatedValue));
      loadXml(xml);
    },
    [selectedObject],
  );

  return {
    importSchema,
    filteredSchemas,
    handleImportSchema,
  };
};
